module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"pt_BR":{"to":"Para","name":"Nome","body":"Corpo da mensagem","stage":"Estágio","company":"Empresa","campaign":"Campanha","created_at":"Data da mensagem (enviada / recebida)","status_identifier":"Estado da mensagem"}}')
  delete Component.options._Ctor
}



//////////////////
// WEBPACK FOOTER
// ./node_modules/@kazupon/vue-i18n-loader/lib!./node_modules/vue-loader/lib/selector.js?type=customBlocks&index=0!./src/components/Campaign/Table.vue
// module id = 129
// module chunks = 0